// extracted by mini-css-extract-plugin
export default {"bannerContainer":"NotificationBanner_bannerContainer__ofl2c","banner":"NotificationBanner_banner__HxaR7"};